import React, { useEffect, useState } from 'react'
import { Accordion, Row } from 'react-bootstrap'
import CustomSelect from '../Utilities/CustomSelect'
import Search from '../Utilities/Search'
import { TraineeTransactionsTableVM } from '../../Structure/ViewModels/Marketer/TraineeTransactionsTableVM'

const TraineeTransactionsTable = (props:{id:string}) => {
    const [vm , setVm] = useState<{viewModel:TraineeTransactionsTableVM}>({viewModel: new TraineeTransactionsTableVM(props.id)})
    const control = vm.viewModel
    useEffect(()=>{
        control.subscribeUpdate(setVm)
        control.getData()
    },[])

    const status = [
      { value: 'settled', label: 'فى الانتظار' },
      { value: 'done', label: 'تم السداد' },
    ];

  return (
    <Accordion>
    <Accordion.Item eventKey="1" className=' overflow-hidden' >
        <Accordion.Header className='overflow-auto'>
            <h4>المتدربين</h4>
        </Accordion.Header>
        <Accordion.Body  className='px-0 px-lg-3'>
            {
                control.Show(
            <Row className='w-100 mx-0'>
                <div className='rounded-3 p-0'>
                    <div className='d-flex flex-wrap justify-content-end'>
                        <div className='d-flex  flex-wrap'>

                            <div className='d-flex flex-column justify-content-center p-2'>
                                <CustomSelect list={status} selected={control.Status} placeHolder='حالة السداد' onSelect={a=>control.Status = a}/>
                            </div>
                            <div className='d-flex flex-column justify-content-center p-2'>
                                <div className='d-flex my-auto'>
                                    <h6 className='px-2 my-auto'>من</h6>
                                    <input type="date" className='input-field p-2 c-pointer' value={control.From} onChange={a=>control.From = a.target.value}  />
                                </div>

                            </div>
                            <div className='d-flex flex-column justify-content-center p-2'>
                                <div className='d-flex my-auto'>
                                    <h6 className='px-2 my-auto'>الى</h6>
                                    <input type="date" className='input-field p-2 c-pointer' value={control.To} onChange={a=>control.To = a.target.value} />
                                </div>

                            </div>
                            <div className='d-flex flex-column justify-content-center p-2'>
                                <Search hasNoSelect  onSearch={a=>{control.Search=a; control.getData()}}/>
                            </div>
                        </div>
                    </div>
                    <div className='d-flex p-3 overflow-x-auto'>
                        <table className='w-100 text-center' style={{minWidth:'500px'}}>
                            <tr className='txt-color-I bg-light-gray'>
                                <th>الاستلام</th>
                                <th>العميل</th>
                                <th>المسار</th>
                                <th>المدفوع</th>
                                <th>سعر العملة</th>
                                <th>القيمة</th>
                                <th> الحساب</th>
                                <th>التاريخ</th>
                            </tr>
                            {
                            control.List.map((item,index)=>(
                                <tr key={index} style={{background:index%2?'white':'rgba(200,200,200,0.2)'}}>
                                    <td>{item.status}</td>
                                    <td>{item.trainee_name}</td>
                                    <td>{item.path_name}</td>
                                    <td>{item.value}</td>
                                    <td>{item.currencyPrice}</td>
                                    <td>{item.amount}</td>
                                    <td>{item.account_name}</td>
                                    <td>{item.date}</td>
                                </tr>
                            ))
                            }
                        </table>
                    </div>
                </div>
            </Row>)
            }
        </Accordion.Body>
    </Accordion.Item>
</Accordion>
  )
}

export default TraineeTransactionsTable
